module.exports = __webpack_public_path__ + "static/media/new_releases-24px.cb5a4dbe.svg";